// extracted by mini-css-extract-plugin
module.exports = {"LogoBox":"Sidebar1_LogoBox__2EVFC","Logo":"Sidebar1_Logo__1ZxiQ","sideBar":"Sidebar1_sideBar__2Blcf"};